﻿export default function findAncestorWithAttr(el, attr) {
    while ((el = el.parentNode) && el !== document.body && !el.hasAttribute(attr));
    return el === document.body ? null : el;
}